import { faSave } from "@fortawesome/free-solid-svg-icons"
import { useState } from "react"
import { useParams } from "react-router"
import { AlterarSenhaController } from "../../../../Controllers/Login/LoginController"
import { AlertConfirmation } from "../../../../Tools/SweetAlerts"
import UnForm from "../../../Form"

interface IAlterarSenhaProps {
    setShow: (show: boolean) => void
}
interface URLParams{
	token: string
}
interface SenhaFormInterface{
	DS_SENHA: string,
	DS_NOVA_SENHA: string,
    DS_CONFIRMACAO: string,
}

export default function AlterarSenhaModal(props: IAlterarSenhaProps) {
    const { token }: URLParams = useParams()

    const [loading, setLoading] = useState(false)

    function handleSenhaFormSubmit(formData: SenhaFormInterface) {
        setLoading(true)
        AlterarSenhaController(formData.DS_SENHA, formData.DS_NOVA_SENHA, token)
        .then(res=>{
            AlertConfirmation("Senha alterada com sucesso!", '', undefined, {cancelButtonText: false, confirmButtonText: false} )
        }).finally(() => {
            setLoading(false)
        })
    }

    return (
        <div>
            {
                <UnForm handleSubmit={handleSenhaFormSubmit}>
                    {
                        ({ getValues }) => (
                            <>
                                <div className="form-group">
                                    <label>Alterar Senha<span className="text-danger">*</span></label>
                                    <div className="col-12 col-lg-8 mt-2">
                                        <label>Senha Atual: *</label>
                                        <UnForm.Input
                                            wrapperClassName="col-md-4"
                                            name={`DS_SENHA`} type={"password"}
                                            registerOptions={{
                                                required: "Insira a Senha Atual"
                                            }}
                                        />
                                    </div>
                                    <div className="col-12 col-lg-8 mt-2">
                                        <label>Nova Senha: *</label>
                                        <UnForm.Input
                                            wrapperClassName="col-md-4"
                                            name={`DS_NOVA_SENHA`} type={"password"}
                                            registerOptions={{
                                                required: "Insira a Nova Senha"
                                            }}
                                        />
                                    </div>
                                    <div className="col-12 col-lg-8 mt-2">
                                        <label>Confirme a Nova Senha: *</label>
                                        <UnForm.Input
                                            wrapperClassName="col-md-4"
                                            name={`DS_CONFIRMACAO`} type={"password"}
                                            registerOptions={{
                                                required: "Confirme a Nova Senha",
                                                validate: valorConfirmacao => {
                                                    const primeiro_valor = getValues("DS_NOVA_SENHA")
                                                    const segundo_valor = getValues("DS_CONFIRMACAO")
                                                    if (primeiro_valor === segundo_valor) {
                                                        return true
                                                    } else {
                                                        return 'Senhas digitadas não são iguais'
                                                    }
                                                }
                                            }}
                                        />
                                    </div>
                                </div>
                                <UnForm.SubmitButton
                                    color="success"
                                    wrapperClassName="w-100 mt-8"
                                    className="w-100"
                                    icon={faSave}
                                    loading={loading}
                                    disabled={loading}
                                    loadingSize={"lg"}
                                >
                                    Salvar
                                </UnForm.SubmitButton>
                            </>
                        )
                    }
                </UnForm>
            }
        </div>
    )
}